'use client';

export default function TrustSection() {
  const cards = [
    {
      emoji: '🛡️',
      colorClass: 'orange' as const,
      title: '전문 기사 · 전문 장비',
      desc: '훈련된 전문 기사와 최신 장비가 파손 없이 안전하게 운반합니다.',
      foot: '✓ 파손 걱정 없는 안전 배송',
    },
    {
      emoji: '📲',
      colorClass: 'blue' as const,
      title: '최적화된 배송 설계 · 트래킹',
      desc: '미리 최적화된 배송 계획과 실시간 배송 정보 업데이트로 정확하게 배송합니다.',
      foot: '✓ 기다림 없는 배송',
    },
    {
      emoji: '💼',
      colorClass: 'green' as const,
      title: '보상 프로그램',
      desc: '파손·오손·분실 시 명확한 기준과 신속한 절차로, 물건뿐 아니라 마음도 지킵니다.',
      foot: '✓ 다양한 보상 프로그램',
    },
  ];

  const iconBg = { orange: '#fde8d6', blue: '#d6e8fc', green: '#d3f0e4' };
  const footColor = { orange: '#e8793c', blue: '#2d7adb', green: '#1e9e6e' };

  return (
    <section className="relative overflow-hidden" style={{ background: '#f0f5fb' }}>
      {/* Ghost word */}
      <span
        className="absolute pointer-events-none select-none font-black leading-none"
        style={{
          fontSize: 'clamp(5rem, 12vw, 10rem)',
          letterSpacing: '-0.02em',
          opacity: 0.055,
          color: '#1a3a5c',
          right: '-1%',
          top: '8%',
          whiteSpace: 'nowrap',
        }}
      >
        TRUST
      </span>

      <div className="relative z-10 max-w-[1000px] mx-auto px-6 py-20 sm:py-32">
        {/* Eyebrow */}
        <p
          className="inline-flex items-center gap-2.5 text-s font-extrabold tracking-[0.22em] uppercase mb-3"
          style={{ color: '#2d7adb' }}
        >
          믿음직한 배송, 당나귀배송
        </p>

        {/* Headline */}
        <h2
          className="font-black leading-[1.15] mb-2.5"
          style={{ fontSize: 'clamp(2rem, 4vw, 2.5rem)', color: '#1a3a5c' }}
        >
          마음 편한 배송 서비스
        </h2>

        {/* Description */}
        <p className="text-base font-medium leading-[1.7] mb-12 max-w-[520px]" style={{ color: '#5a7898' }}>
          전문 기사부터 보상 프로그램까지, 모든 단계에서 지켜 드립니다.
        </p>

        {/* Trust cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {cards.map((card, i) => (
            <div
              key={i}
              className="bg-white rounded-[22px] overflow-hidden hover:-translate-y-1 transition-all duration-200"
              style={{
                border: '1.5px solid #e4edf8',
                boxShadow: '0 4px 24px rgba(26,58,92,.07)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.boxShadow = '0 12px 40px rgba(26,58,92,.13)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.boxShadow = '0 4px 24px rgba(26,58,92,.07)';
              }}
            >
              {/* Card top */}
              <div className="px-7 pt-8 pb-6">
                <div
                  className="w-14 h-14 rounded-2xl flex items-center justify-center text-2xl mb-4"
                  style={{ background: iconBg[card.colorClass] }}
                >
                  {card.emoji}
                </div>
                <h3 className="text-base font-extrabold mb-2.5" style={{ color: '#1a3a5c' }}>
                  {card.title}
                </h3>
                <p className="text-sm leading-[1.65]" style={{ color: '#5a7898' }}>
                  {card.desc}
                </p>
              </div>

              {/* Card footer */}
              <div
                className="px-7 py-3.5 flex items-center gap-1.5 text-xs font-semibold"
                style={{
                  borderTop: '1px solid #eef3fa',
                  color: footColor[card.colorClass],
                }}
              >
                {card.foot}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
